const persianMonths = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

const getMonthNumberFromDate = (dateString = "") => {
  const parts = dateString.split("/");

  const month = parts[1];

  return month?.charAt(1);
};

export const convertDateStringToDaysAndMonthInPersian = (dateInString) => {
  return dateInString
    ? dateInString.slice(-2).replaceAll("0", "") +
    " " +
    persianMonths[getMonthNumberFromDate(dateInString) - 1] +
    " " +
    dateInString.slice(0, 4)
    : ""; // not showing undefined when the dateInString is not avaiable yet
};
